import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { ApiResponse } from '../models/api-response';
import { NotificationDto, NotificationSearchDto, NotificationSummaryDto } from '../models/notification';
import { BaseService } from './Base.service';

@Injectable({ providedIn: 'root' })
export class NotificationService extends BaseService<NotificationDto> {
  private notifUrl = `${environment.apiUrl}/Notifications`;

  constructor(http: HttpClient) {
    super(http);
    this.apiUrl = `${environment.apiUrl}/Notifications`;
  }

  getSummary(): Observable<ApiResponse<NotificationSummaryDto>> {
    return this.http.get<ApiResponse<NotificationSummaryDto>>(
      `${this.notifUrl}/GetSummary`,
      { headers: this.getHeaders() }
    );
  }

  listPaged(search: NotificationSearchDto): Observable<ApiResponse<NotificationDto[]>> {
    const params = new URLSearchParams({
      pageNumber: String(search.pageNumber),
      pageSize: String(search.pageSize),
      ...(search.isRead !== undefined ? { isRead: String(search.isRead) } : {}),
    });
    return this.http.get<ApiResponse<NotificationDto[]>>(
      `${this.notifUrl}/ListPaged?${params}`,
      { headers: this.getHeaders() }
    );
  }

  markRead(id: string): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(
      `${this.notifUrl}/MarkRead/${id}`,
      null,
      { headers: this.getHeaders() }
    );
  }

  markAllRead(): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(
      `${this.notifUrl}/MarkAllRead`,
      null,
      { headers: this.getHeaders() }
    );
  }
}
